import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styles from './styles.module.scss';

const SuspenseLoading = () => {
  return <div className={styles.loading}>
    <Spin indicator={<LoadingOutlined spin />} size="large" />
  </div>
};

export default SuspenseLoading;
